import { render, staticRenderFns } from "./pc_header.vue?vue&type=template&id=cf5797c2&scoped=true"
import script from "./pc_header.vue?vue&type=script&lang=js"
export * from "./pc_header.vue?vue&type=script&lang=js"
import style0 from "./pc_header.vue?vue&type=style&index=0&id=cf5797c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5797c2",
  null
  
)

export default component.exports